import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { MEDIA } from 'vars/media'

export const ErrorDescriptionSC = styled.div`
  min-height: var(--iconHeight);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  max-width: 600px;
  gap: 24px;
  ${ButtonSC} {
    align-self: flex-start;
  }
  ${MEDIA.TOUCH} {
    max-width: min(400px, 80%);
    min-height: unset;
    ${TextBoxSC} {
      text-align: center;
    }
    ${ButtonSC} {
      align-self: center;
    }
  }
`

export const ErrorDescriptionWrapper = styled.div`
  --iconHeight: 240px;
  --iconWidth: 200px;
  --direction: row;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: var(--direction);
  --gap: 120px;
  column-gap: var(--gap);
  ${MEDIA.TOUCH} {
    --iconHeight: 149px;
    --iconWidth: 124px;
    --direction: column;
    --gap: 32px;
    justify-content: center;
    row-gap: var(--gap);
  }
  > ${IconSC} {
    height: var(--iconHeight);
    width: var(--iconWidth);
  }
`
